// extracted by mini-css-extract-plugin
export default {"card":"blockTwoSettings_card__OQxZs","content":"blockTwoSettings_content__xoe8M","select":"blockTwoSettings_select__wxfbu"};